import { useCallback, useState } from 'react'
import { inviteToOrganization } from 'src/redux/slices/user/endpoints'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import { Button, Fade, Grid, IconButton, TextField } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import SendIcon from '@material-ui/icons/Send'

////// Types
type InviteUserProps = {
  organization_id: number
}

///// Component
const InviteUser: React.FC<InviteUserProps> = ({ organization_id }) => {
  const [invitingUser, setInvitingUser] = useState(false)
  const [trigger, { data, isLoading }] = inviteToOrganization.useMutation()
  const [email, setEmail] = useState('')
  const toggleInvitingUser = useCallback(() => {
    setInvitingUser((prev) => !prev)
    setEmail('')
  }, [])
  const handleEmail = useCallback((e: TextFieldOnChangeEvent) => {
    setEmail(e.target.value)
  }, [])

  const invite = useCallback(() => {
    trigger({ organization_id, email })
    toggleInvitingUser()
  }, [organization_id, email, toggleInvitingUser])
  return (
    <>
      {invitingUser && (
        <Fade in={true} timeout={500}>
          <Grid container alignItems='center' spacing={3}>
            <Grid item>
              <TextField
                fullWidth
                // onChange={(e) => handleChange({parameter: "value", target: "long"}, e)}
                label='Email'
                value={email}
                helperText='Add a user to the team.'
                type='email'
                onChange={handleEmail}
              />
            </Grid>
            <Grid item>
              <Button variant='contained' size='small' endIcon={<SendIcon />} onClick={invite}>
                Invite
              </Button>
            </Grid>
            <Grid item>
              <IconButton onClick={toggleInvitingUser}>
                <CancelIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Fade> //
      )}
      {!invitingUser && (
        <Button onClick={toggleInvitingUser} variant='contained' color='primary' size='small'>
          Add Team Member
        </Button>
      )}
    </>
  )
}
export default InviteUser
